import { PartnersTranslationDTO } from "../domain/models/dto/PartnersDTO";
import { IFile } from "../domain/models/File";
import { IPartners } from "../domain/models/Partners";
import { BaseModelImpl } from "./BaseModelImpl";

export class PartnersModel
    extends BaseModelImpl<IPartners>
    implements IPartners
{
    id: string;
    files?: IFile[];

    translations: PartnersTranslationDTO[];
    availableLangs?: string[];
    isActive: boolean;
    websiteUrl?: string;

    updatorId?: string;
    creatorId: string;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IPartners) {
        super();
        this.assignData(data);
    }
}
